module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/solution-02_sp-dac3c9fd6a8b4d0eebf16b7956b5251d.jpg";